import { QueryDtoOf } from '@40seas/entities/common';
import { PaymentMethod } from '@40seas/entities/payment-methods';

export class PaymentMethodQueryDto extends QueryDtoOf(PaymentMethod) {}
